import React from "react";
import { LineChart, axisClasses } from "@mui/x-charts";

interface SeriesLine {
  data: number[];
  label: string;
  color?: string;
}

interface MuiMultiLineChartProps {
  xLabels: string[];
  series: SeriesLine[];
  height?: number;
}

const MuiMultiLineChart: React.FC<MuiMultiLineChartProps> = ({
  xLabels,
  series,
  height = 300,
}) => {
  return (
    <LineChart
      height={height}
      xAxis={[{ scaleType: "point", data: xLabels }]}
      series={series.map((s) => ({
        data: s.data,
        label: s.label,
        color: s.color ?? "#3e59e3",
      }))}
      sx={{
        [`& .${axisClasses.left} .MuiChartsAxis-tickLabel`]: {
          fontSize: 12,
        },
      }}
    />
  );
};

export default MuiMultiLineChart;
